// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOSFilterSelect-module_inactive_QZ91k {
  pointer-events: none;
}

.BOSFilterSelect-module_menu_simple_LQRNe {
}

.BOSFilterSelect-module_list_gDj31 {
  width: 100%;
}

.BOSFilterSelect-module_row_BAUcd {
  height: 100%;
  align-items: center;
  padding: 0;
}

.BOSFilterSelect-module_row_BAUcd li {
  width: 100%;
}

.BOSFilterSelect-module_no_content_mZagL {
  font-style: italic;
  color: var(--bp-gray3) !important;
}

.BOSFilterSelect-module_required_input_V0IBu input::placeholder {
  color: var(--required-input);
}

.BOSFilterSelect-module_inactive_item_L4yOh {
  color: var(--muted-text) !important;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/BOSFilterSelect/BOSFilterSelect.module.css"],"names":[],"mappings":"AAAA;EAEE,oBAAoB;AACtB;;AAEA;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB","sourcesContent":[".inactive {\n  composes: inactive from 'Styles/styles.module.css';\n  pointer-events: none;\n}\n\n.menu_simple {\n  composes: filter_selection_menu from 'Styles/styles.module.css';\n}\n\n.list {\n  width: 100%;\n}\n\n.row {\n  height: 100%;\n  align-items: center;\n  padding: 0;\n}\n\n.row li {\n  width: 100%;\n}\n\n.no_content {\n  font-style: italic;\n  color: var(--bp-gray3) !important;\n}\n\n.required_input input::placeholder {\n  color: var(--required-input);\n}\n\n.inactive_item {\n  color: var(--muted-text) !important;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inactive": `BOSFilterSelect-module_inactive_QZ91k ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inactive"]}`,
	"menu_simple": `BOSFilterSelect-module_menu_simple_LQRNe ${___CSS_LOADER_ICSS_IMPORT_0___.locals["filter_selection_menu"]}`,
	"list": `BOSFilterSelect-module_list_gDj31`,
	"row": `BOSFilterSelect-module_row_BAUcd`,
	"no_content": `BOSFilterSelect-module_no_content_mZagL`,
	"required_input": `BOSFilterSelect-module_required_input_V0IBu`,
	"inactive_item": `BOSFilterSelect-module_inactive_item_L4yOh`
};
export default ___CSS_LOADER_EXPORT___;
